import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import { ArrowDownward } from '@mui/icons-material';
import styles from './CreateStoresGroupModal.module.css';
import { CreatestoresGroupModalProps } from './CreateStoresGroupModal.types';

const CreateStoresModal: FC<CreatestoresGroupModalProps> = ({
  isOpen,
  onClose,
  selectedStores,
  currentGroup,
  groupName,
  emptyStoreGroups,
  onClick,
  isLoading,
}) => {
  const { t } = useTranslation();

  const hasEmptyGroups = emptyStoreGroups.length > 0;
  const storesSelected = selectedStores.map((store) => store.storeNo).join(', ');

  return (
    <Modal
      className={styles.moveStores}
      isOpen={isOpen}
      onClose={onClose}
      headerContent={hasEmptyGroups ? t('createNewStoreGroup.createAndDelete.title') : t('moveStoresModal.title')}
      data-testid="Modal"
      showTitleDivider
      bodyContent={
        <div className={styles.moveStoresBody}>
          <div className={styles.newGroupSelection}>
            <div className={styles.currentGroupTitle}>Stores Selected:</div>
            <div className={styles.storeFont}>{storesSelected}</div>
            <div className={styles.storeFont}>{`(${currentGroup})`}</div>
            <ArrowDownward sx={{ fontSize: '20px' }} />
            <div className={styles.newGroupDropdown}>
              <div className={styles.currentGroupTitle}>New Store Group:</div>
              <div className={styles.storeFont}>{groupName}</div>
            </div>
            {hasEmptyGroups && (
              <div className={styles.storeFont}>
                The {emptyStoreGroups.join(', ')} store group(s) will be deleted because there are no stores remaining.
              </div>
            )}
          </div>
        </div>
      }
      footerContent={
        <div className={styles.footer}>
          <div className={styles.buttons}>
            <Button variant={ButtonVariants.Secondary} onClick={onClose} type="button">
              {t('createNewStoreGroup.createAndDelete.cancel')}
            </Button>
            <Button onClick={onClick} type="button" isLoading={isLoading}>
              {hasEmptyGroups ? t('createNewStoreGroup.createAndDelete.confirm') : t('common.confirm')}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default CreateStoresModal;
